// Configuration centralisée pour les vidéos

export const VIDEO_CONFIG = {
  // Formats supportés par ordre de préférence
  supportedFormats: ['mp4', 'webm', 'ogg'],
  
  // Paramètres par défaut
  defaultSettings: {
    preload: 'metadata',
    playsInline: true,
    crossOrigin: 'anonymous'
  },
  
  // Paramètres selon le contexte
  contextSettings: {
    thumbnail: {
      controls: false,
      muted: true,
      autoPlay: false,
      preload: 'none', // Pas de preload pour les thumbnails
      loop: false
    },
    carousel: {
      controls: true,
      muted: false,
      autoPlay: false,
      preload: 'metadata', // Métadonnées seulement
      loop: false
    },
    fullscreen: {
      controls: true,
      muted: false,
      autoPlay: false,
      preload: 'metadata', // Éviter 'auto' pour les gros fichiers
      loop: false
    }
  },
  
  // Messages d'erreur
  errorMessages: {
    loadError: 'Erreur de chargement de la vidéo',
    notSupported: 'Format vidéo non supporté',
    networkError: 'Erreur réseau lors du chargement',
    unavailable: 'Vidéo indisponible'
  },
  
  // Timeouts
  timeouts: {
    loadTimeout: 10000, // 10 secondes
    availabilityCheck: 5000 // 5 secondes
  }
};

// URLs des vidéos avec fallbacks
// TEMPORAIRE: URLs de placeholder - seront remplacées après déploiement
export const VIDEO_URLS = {
  lafrance: {
    primary: 'https://via.placeholder.com/800x600/000000/FFFFFF?text=Video+Lafrance',
    fallback: null,
    poster: null,
    isPlaceholder: true
  },
  philippe_clas: {
    primary: 'https://via.placeholder.com/800x600/000000/FFFFFF?text=Video+Philippe+Classique',
    fallback: null,
    poster: null,
    isPlaceholder: true
  },
  philippe_esp: {
    primary: 'https://via.placeholder.com/800x600/000000/FFFFFF?text=Video+Philippe+Espagnol',
    fallback: null,
    poster: null,
    isPlaceholder: true
  },
  philippe_mod: {
    primary: 'https://via.placeholder.com/800x600/000000/FFFFFF?text=Video+Philippe+Moderne',
    fallback: null,
    poster: null,
    isPlaceholder: true
  },
  rachid1930: {
    primary: 'https://via.placeholder.com/800x600/000000/FFFFFF?text=Video+Rachid+1930',
    fallback: null,
    poster: null,
    isPlaceholder: true
  },
  rachidchen: {
    primary: 'https://via.placeholder.com/800x600/000000/FFFFFF?text=Video+Rachid+Chen',
    fallback: null,
    poster: null,
    isPlaceholder: true
  },
  machiya: {
    primary: 'https://via.placeholder.com/800x600/000000/FFFFFF?text=Video+Machiya',
    fallback: null,
    poster: null,
    isPlaceholder: true
  }
};

/**
 * Obtient l'URL de la vidéo avec fallback
 * @param {string} videoKey - Clé de la vidéo
 * @returns {string} - URL de la vidéo
 */
export const getVideoUrl = (videoKey) => {
  const videoConfig = VIDEO_URLS[videoKey];
  if (!videoConfig) {
    console.warn(`Configuration vidéo non trouvée pour: ${videoKey}`);
    return null;
  }
  
  return videoConfig.primary;
};

/**
 * Obtient les paramètres optimisés pour un contexte
 * @param {string} context - Contexte d'utilisation
 * @returns {Object} - Paramètres optimisés
 */
export const getContextSettings = (context) => {
  return {
    ...VIDEO_CONFIG.defaultSettings,
    ...VIDEO_CONFIG.contextSettings[context] || VIDEO_CONFIG.contextSettings.carousel
  };
};